export default __webpack_public_path__ + "static/pro-contact-b0f467063300462c09bab308d0fa9bc6.png";